/**
  * 学校信息模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const schoolApi = {
    GetSchoolTreeList: `${base.qa}/School/GetSchoolTreeList`,
    SaveDataItem: `${base.qa}/School/SaveDataItem`,
    DelSchoolInfo: `${base.qa}/School/DelSchoolInfo`,
    GetSchoolInfo: `${base.qa}/School/GetSchoolInfo`,

}

const school = {
    GetSchoolTreeList () {
        return axios.get(schoolApi.GetSchoolTreeList)
    },
    SaveDataItem (params) {
        return axios.post(schoolApi.SaveDataItem, params)
    },
    DelSchoolInfo (params) {
        return axios.post(schoolApi.DelSchoolInfo, params)
    },
    GetSchoolInfo (params) {
        console.log(params);
        return axios.get(schoolApi.GetSchoolInfo, { params: { schoolid: params } })
    },
}


export default school;